export default class CompanyService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }
  
  getCompany(entityId, companyId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/company/get/${entityId}/${companyId}`);
  }

  editCompany(company) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/company/edit', company);
  }

  listCompanies(filterParams) {
    let query = '';

    query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
    query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
    query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
    query += `&ascending=${filterParams.pageCriteria.ascending}`;
    query += `&entityId=${filterParams.entityId}`;

    if (filterParams.companyType.id) {
      query += `&companyType=${filterParams.companyType.id}`;
    }

    query += `&legalName=${filterParams.legalName}`;

    return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/company/list' + query);
  }

  updateCompanyState(entityId, companyId, state) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/company/update/${entityId}/${companyId}/${state}`);
  }
}



// WEBPACK FOOTER //
// ./client/app/components/company/company.service.js